import { GET_PARTNER_SITUATIONS } from '../mutation-types'

const state = { all: [] }

const mutations = {
  [GET_PARTNER_SITUATIONS] (state, situations) {
    state.all = situations
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/partnerSituations.js